import React  from 'react';
import './Question.css';
import '../Button/Button';

const question=(props) => {
  const style={
    width: '5em',
    backgroundColor: 'white',
    font: 'inherit',
    border: '1px solid blue',
    padding: '8px',
    cursor: 'pointer' };

    const styleChosen={
      width: '5em',
      backgroundColor: 'yellow',
      font: 'inherit',
      border: '1px solid blue',
      padding: '8px',
      cursor: 'pointer' };

function styleSelector(historyValue, n)
{if(historyValue===n) {return styleChosen;} else {return style;}}

//  <p></p>  These buttons were in the return  but comments don't work!
//        <button onClick={props.clickBack} > Previous Question</button>
//        <button onClick={props.clickNext} > Next Question</button>



return(

  <div className="Question">
      <span  id="number-block"> {props.questionNumber +1}</span>
      <span> &emsp; &emsp; &emsp;{props.questionHeader}</span>
      <p></p>
      &emsp;&emsp;&emsp;&emsp;
    <button  style={styleSelector(props.historyValue,1)} onClick={props.clickHistory.bind(this,1)} > FA</button>
    &emsp;
    <button style={styleSelector(props.historyValue,2)} onClick={props.clickHistory.bind(this,2)} > LA</button>
    &emsp;
    <button style={styleSelector(props.historyValue,3)} onClick={props.clickHistory.bind(this,3)} > PA</button>
    &emsp;
    <button style={styleSelector(props.historyValue,4)} onClick={props.clickHistory.bind(this,4)} > NA</button>

   <p id="p_wrap">{props.questionBody}</p>


  </div>
)
};
export default question;



// WEBPACK FOOTER //
// ./src/components/Question/Question.js